<template>
  <div>
    <btn-back></btn-back>
    <el-card>
      <el-row>
        <el-col :span="8">
          <DataBlock 
            :dataToShow="{
              key: $t('production_area'),
              value: productionZones.name}">
          </DataBlock>
          <DataBlock 
            :dataToShow="{
              key: 'Id',
              value: productionZones.id}"
            :size="'mini'"
            >
          </DataBlock>
          <DataBlock 
            :dataToShow="{
              key: 'Description',
              value: productionZones.description}"
            :size="'mini'">
          </DataBlock>
        </el-col>
        <el-col :span="8">
          <DataBlock 
            :dataToShow="{
              key: 'Id du capteur',
              value: productionZones.beaconId}"
            :size="'mini'">
          </DataBlock>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row v-if="isSuperAdmin">
        <h2>Node configuration</h2>
        <p>{{ productionZones }}</p>
      </el-row>

     <!-- <el-row :gutter="20">
        <el-col :span="12">
          <DataBlock 
            :dataToShow="{
              key: 'production zone',
              value: manufacturingOrder.productionZone.length}">
          </DataBlock>
          <el-table
            :data="productionZones"
            style="width: 100%">
            <el-table-column
              prop="name"
              label="Nom"
              width="180">
            </el-table-column>
          </el-table>
        </el-col>

        <el-col :span="12">
          <DataBlock 
            :dataToShow="{
              key: 'operators',
              value: manufacturingOrder.operators.length}">
          </DataBlock>
           <el-table
            :data="operators"
            style="width: 100%">
            <el-table-column
              prop="lastname"
              label="Nom"
              width="180">
            </el-table-column>
            <el-table-column
              prop="firstname"
              label="Prénom"
              width="180">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      
      <h2>Historique de l'ordre de fabrication</h2>
      <el-row>
        <el-table
          :data="historyMO"
          height="250"
          style="width: 100%">
          <el-table-column
           label="Zone">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row[0] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Début">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ getReadableFormat(scope.row[2]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Fin">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ getReadableFormat(scope.row[3]) }}</span>
            </template>
        </el-table-column>
        </el-table>
      </el-row>

      <h2>Statistique</h2>
      <div>
        <vue-apex-charts type=bar height=350 width="100%" :options="chartBarTest.chartOptions" :series="chartBarTest.series" />
      </div> -->


      <!-- <p>{{ productionZones }}</p> -->
      <!-- <hr>
      <p>{{ productionZones }}</p>
      <hr>
      <p>{{ operators }}</p> -->
    </el-card>
  </div>
</template>

<script>
import { history } from '../data/history3'
import { chartBar1 } from '../data/chartTemplate'
import DataBlock from '../components/DataBlock.vue'
import DateTimaManipulation from '@/mixins/DateTimeManipulation.js'
import dataToChart from '../mixins/dataToChart'
import BtnBack from '../components/BtnBack.vue'

export default {
  name: 'production-zone-details',
  components: {
    DataBlock,
    BtnBack
  },
  props: {
    
  },
  data() {
    return {
      msg: 'Hi there!',
      id: '',
      historyMO: [],
      stats: {},
      zoneBarChart: {},
      seriesLabel: {},
      chartBarTest:{},
      userFrom: '',
      isSuperAdmin: false
    }
  },
  mounted() {
  },
  created() {
   this.computeDatasAtStart();
   this.isSuperAdmin = this.$store.getters.isSuperAdmin;
  },
  watch: {
    manufacturingOrder() {
      this.historyMO = history.filter( h => h.includes('of1'));
    },
    $route () {
      this.computeDatasAtStart();
    }
  },
  computed: {
    manufacturingOrder() {
      const manufacturingOrders = this.$store.getters.manufacturingOrders;
      return manufacturingOrders.find( mo => mo.id === this.id);
    },
    productionZones() {
      const productionZones = this.$store.getters.productionZones;
      return productionZones.find( pz => pz.id === this.id);
    },
    operators() {
      const operators = this.$store.getters.operators;
      return operators !== undefined ? operators.filter( op => this.manufacturingOrder.operators.includes(op.id)) : [];
    }
  },
  methods: {
    computeDatasAtStart: function() {
      this.id = this.$route.params.id;
      this.chartBarTest = JSON.parse(JSON.stringify(chartBar1));
      this.chartBarTest.series[0].data = [10, 10, 10];
      let computedLog = this.logsToBarChartByGroup(history);
      this.chartBarTest.series[0].data = computedLog.data.operator;
      this.chartBarTest.series[1].data = computedLog.data.maintenance;
      this.chartBarTest.series[2].data = computedLog.data.responsable;
      this.chartBarTest.series[3].data = computedLog.data.Déplacement;
      this.chartBarTest.chartOptions.xaxis.categories = computedLog.cat;
      this.chartBarTest.chartOptions.tooltip.y = {
          formatter: function (val) {
            return `${new Date(val).getDate() * 24 + new Date(val).getHours()}H${new Date(val).getMinutes()}`;
          }
      };
      this.chartBarTest.chartOptions.yaxis = {
        labels: {
          formatter: function (val) {
            return `${new Date(val).getDate() * 24 + new Date(val).getHours()}H00`;
          }
        }
      }
    },
    getZoneForThisMO: function(arrayId, collectionToFilter) {
      let zones = []
      if(arrayId !== undefined && collectionToFilter !== undefined) {
        arrayId.forEach(id => {
          zones.push(collectionToFilter.find(el => el.id === id));
        });
      }
      return zones;
    },
    computeStats: function(histo) {
      let zones = {};
      histo.forEach( log => {
        if(zones[log[0]] == undefined) {
          zones[log[0]] = log[3] - log[2];
        } else {
          zones[log[0]] += log[3] - log[2];
        }
      })
      return zones
    },
    readyToChart: function(data) {
      const label = [];
      const series = [];
      for (const [key, value] of Object.entries(data)) {
        label.push(key);
        series.push(value);
      }
      return {label, series};
    }
  },
  mixins: [DateTimaManipulation, dataToChart]
}
</script>

<style scoped>

</style>